<template>
  <b-modal
    id="confirm-modal-notification"
    centered
    footer-class="d-flex justify-content-between"
  >
    <template #modal-header>
      <!-- Título de modal -->
      <h5 class="modal-title">
        Confirmación
      </h5>
    </template>
    <!-- Botón de cancelar y emitir -->
    <template #modal-footer>
      <div>
        <b-button
          v-ripple.400="'rgba(255, 255, 255, 0.15)'"
          variant="danger"
          size="sm"
          @click="$emit('cancel')"
        >
          <feather-icon
            icon="ArrowLeftIcon"
            class="mr-25"
          />
          Cancelar
        </b-button>
      </div>
      <div>
        <b-button
          v-ripple.400="'rgba(255, 255, 255, 0.15)'"
          variant="primary"
          size="sm"
          @click="$emit('emit')"
        >
          <feather-icon
            icon="UploadCloudIcon"
            class="mr-25"
          />
          Emitir notificación
        </b-button>
      </div>
    </template>
    <!-- Contenido -->
    <b-card-text>
      Autorizo que la información ingresada con anterioridad sea emitida como notificación a un usuario correspondiente.
    </b-card-text>
  </b-modal>
</template>

<script>
import {
  BButton,
  BCardText,
} from 'bootstrap-vue'
import Ripple from 'vue-ripple-directive'

export default {
  components: {
    BButton,
    BCardText,
  },
  directives: {
    Ripple,
  },
}
</script>
